export default __webpack_public_path__ + "media/images/portfolio/gallery-07-390x230-a7f71592fc4631437f03362c327986f1.jpg";